// HalalCertification.jsx
import React from "react";

export default function HalalCertification() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Halal Certification
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Halal Certification for Food & Export Compliance
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists businesses in obtaining Halal
            Certification to meet religious, quality, and export compliance
            requirements for food products, ingredients, and manufacturing
            processes.
          </p>
          <p className="text-gray-700">
            From preparing comprehensive application documentation and
            coordinating Shariah and technical audits to ensuring facility
            compliance and certification issuance, the entire process is managed
            professionally to meet international Halal standards.
          </p>
        </div>

        {/* Right: Image (square for consistency) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/6646917/pexels-photo-6646917.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Halal certification audit and compliance process"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for Halal Certification
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks helps businesses compile all technical,
              operational, and compliance documentation required by Halal
              certification authorities for audit and approval.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>
                  Business registration documents including trade license,
                  incorporation certificate, or partnership deed.
                </li>
                <li>
                  Product and ingredient details with complete formulation,
                  supplier certificates, and Halal declarations for critical
                  components.
                </li>
                <li>
                  Manufacturing process information including flow charts,
                  cleaning protocols, and cross-contamination prevention measures.
                </li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm provides specialized Halal certification support,
              combining technical expertise with Shariah compliance knowledge and
              established relationships with recognized certification bodies.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Expertise in Halal Compliance Standards
                </h3>
                <p className="text-gray-700 text-sm">
                  Deep understanding of Halal requirements across food
                  categories, manufacturing processes, and international export
                  standards recognized by global Islamic authorities.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Accurate Certification Support
                </h3>
                <p className="text-gray-700 text-sm">
                  Meticulous documentation preparation, audit coordination, and
                  compliance gap analysis to ensure smooth certification process
                  with minimal revisits or objections.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Trusted Professional Assistance
                </h3>
                <p className="text-gray-700 text-sm">
                  End-to-end management from application submission through
                  Shariah/technical audits, corrective actions, and certificate
                  issuance with ongoing compliance advisory support.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
